import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const StyledCrmEnrichmentJobTypeButton = styled.button<{ isSelected: boolean }>`
    box-sizing: content-box;
    width: 182px;
    height: 182px;
    padding: ${({ isSelected }) => (isSelected ? `11px` : `12px`)};
    border-radius: 8px;
    border: ${({ isSelected }) =>
        isSelected ? `2px solid ${colorsPalettes.blue[400]}` : `1px solid ${colorsPalettes.bluegrey[200]}`};
    background-color: ${colorsPalettes.bluegrey[100]};

    &:hover {
        box-shadow:
            0px 1px 2px 0px rgba(56, 56, 56, 0.1),
            0px 4px 4px 0px rgba(56, 56, 56, 0.09),
            0px 9px 6px 0px rgba(56, 56, 56, 0.05),
            0px 17px 7px 0px rgba(56, 56, 56, 0.01),
            0px 26px 7px 0px rgba(56, 56, 56, 0);
    }
`;

export const StyledCrmEnrichmentJobTypeButtonIcon = styled(SWReactIcons)`
    width: 90px;
    height: 90px;
    margin: ${({ iconName }) => (iconName === "hubspot-cloud" ? `2px 0 0` : `0 8px 16px 0`)};
`;

export const StyledCrmEnrichmentJobTypeButtonIconWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 106px;
`;

export const StyledCrmEnrichmentJobTypeButtonTitle = styled.p`
    width: 100%;
    margin: 0;
    padding: 4px 0 4px;
    ${setFontVariant("subTitle3", colorsPalettes.carbon[500])};
`;

export const StyledCrmEnrichmentJobTypeButtonDescription = styled.p`
    width: 100%;
    margin: 0;
    ${setFontVariant("input2", colorsPalettes.carbon[400])};
`;
